module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-2-mobile.e7a5bb6d.jpg";